import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-sign-out',
    templateUrl: './sign-out.component.html',
    styleUrl: './sign-out.component.sass',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SignOutComponent {}
